import { SortCategories } from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';
import { INITIAL_PAGINATION, ListMode, ListState } from '../../../shared/list-controller/list-controller';
import { RelationRequestTables } from '../../grid-table-factory/table-creator.enum';
import { RelationPageTabs, RelationRequestKnd } from '../../relation-request.enum';
import {
  DoctorLink,
  FilterValue,
  RelationRequestPageTexts,
  RelationRequestsPageConfig,
} from '../../relation-request.interface';
import { RelationRequestsTables } from '../../relation-request.tokens';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';

export class DoctorLinkRequestListComponent extends ManageRelationRequestComponent<DoctorLink, FilterValue> {}

export const DOCTOR_LINK_TABLES: RelationRequestsTables = {
  [RelationPageTabs.LIST]: RelationRequestTables.DOCTOR_LINKED_REQUESTS,
  [RelationPageTabs.REQUESTS_RECEIVED]: RelationRequestTables.DOCTOR_RECEIVED_LINK_REQUEST,
  [RelationPageTabs.REQUESTS_SENT]: RelationRequestTables.DOCTOR_SENT_LINK_REQUEST,
};

const DOCTOR_LINK_PAGE_TEXTS: RelationRequestPageTexts = {
  noAcceptedRequestsHint: 'NO_ACCEPTED_DOCTOR_LINKS_HINT',
  noReceivedRequestsHint: 'NO_RECEIVED_DOCTOR_LINKS_HINT',
  noSentRequestsHint: 'NO_SENT_DOCTOR_LINKS_HINT',
  acceptedRequestsTabTitle: 'DOCTOR_LINKS_TAB_TITLE',
  searchFieldLabel: 'SEARCH_DOCTOR_FIELD_LABEL',
};

const DOCTOR_INITIAL_STATE: ListState<RelationPageTabs, FilterValue> = {
  context: RelationPageTabs.LIST,
  pagination: INITIAL_PAGINATION,
  sorting: SortCategories.SCORE_DESC,
  filtering: '',
  mode: ListMode.BROWSE,
  queryKeyword: '',
};

export const DOCTOR_PAGE_CONFIG: RelationRequestsPageConfig<FilterValue> = {
  kind: RelationRequestKnd.DOCTOR_LINK,
  texts: DOCTOR_LINK_PAGE_TEXTS,
  filter: null,
  initialState: DOCTOR_INITIAL_STATE,
  allowedChat: false,
};
